import { useMemo, useState } from "react";
import { usePrecepteePeriodsQuery } from "@/hooks/roster-craete/usePrecepteePeriodsQuery";
import { getPrecepteeDaysByNurseId } from "@/utils/precepteePolicy";
import { useRosterCreateDerivedNurses } from "@/pages/roster-create/hook/useRosterCreateDerivedNurses";
import type { CopyNurses } from "@/utils/rosterCreate-util";

export function useIssuedPrecepteeStats({ nurses, groupId, year, month }: {
  nurses: CopyNurses;
  groupId: string;
  year: number;
  month: number;
}) {
  const [included, setIncluded] = useState(false);
  const query = usePrecepteePeriodsQuery({ groupId, year, month });
  const days = useMemo(
    () => getPrecepteeDaysByNurseId(query.data?.items, year, month),
    [query.data, year, month]
  );
  const { statsNurses } = useRosterCreateDerivedNurses({
    copyNursesWithWanted: nurses,
    includePrecepteeInValidationCount: true,
    includePrecepteeInStatsCount: included,
    precepteeDaysByNurseId: days,
  });
  const hasTarget = days.size > 0;
  const pending = Boolean(groupId) && query.isPending;
  const disabled = !groupId || pending || query.isError || !hasTarget;
  const label = pending
    ? "프리셉티 확인 중"
    : query.isError
      ? "프리셉티 조회 실패"
      : !hasTarget
        ? "프리셉티 없음"
        : included ? "프리셉티 포함" : "프리셉티 제외";
  return { statsNurses, included, setIncluded, disabled, label, pending, isError: query.isError, refetch: query.refetch };
}
